module.exports = __webpack_public_path__ + "static/media/Me2.73269fe2.JPG";